<template>
  <div class="searchBox">
    <el-form :inline="true" :model="formStu" label-width="90px" class="searchForm">
      <el-form-item label="学员ID:">
        <el-input v-model="formStu.id" placeholder="输入ID" style="width: 175px"></el-input>
      </el-form-item>
      <el-form-item label="学员昵称:">
        <el-input v-model="formStu.stuName" placeholder="输入昵称"></el-input>
      </el-form-item>
      <el-form-item label="班级名称:" v-if="className">
        <el-input
          v-model="formStu.className"
          placeholder="输入班级名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input
          v-model="formStu.phone"
          placeholder="输入多个用空格分隔"
        ></el-input>
      </el-form-item>
      <el-form-item label="微信号:">
        <el-input
          v-model="formStu.weixinId"
          placeholder="输入微信号"
        ></el-input>
      </el-form-item>
      <el-form-item label="学生状态:">
        <el-select v-model="formStu.status" clearable style="width: 175px">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报名时间:" v-if="signupDate">
        <el-date-picker
          v-model="formStu.signupDate"
          type="daterange"
          placeholder="报名日期"
          format="yyyy-MM-dd"
          placement="bottom-end"
          style="width: 250px; font-size: 10px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="班级分组:" v-if="groupName">
        <el-input
          v-model="formStu.groupName"
          placeholder="输入班级分组名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="助教老师:" v-if="teacherId">
        <Select v-model="formStu.teacherId" clearable style="width: 178px">
          <Option
            v-for="item in queryData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <!-- <el-input v-model="formStu.teacherId" placeholder="请输入助教老师姓名"></el-input> -->
      </el-form-item>
      <el-form-item label="会员有效期:" 
        label-width="100px" >
        <el-date-picker
          v-model="formStu.expireDate"
          type="daterange"
          placeholder="会员有效期"
          format="yyyy-MM-dd"
          placement="bottom-end"
          :picker-options="pickerOptions2"
          style="width: 250px; font-size: 10px"
        ></el-date-picker>
        <el-form-item label="入班时间:" label-width="130px" v-if="joinTime">
          <el-date-picker
            v-model="formStu.joinTime"
            type="daterange"
            placeholder="入班时间"
            format="yyyy-MM-dd"
            placement="bottom-end"
            style="width: 250px; font-size: 10px"
          ></el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="学员课程结束时间:"
        label-width="150px"
        v-if="endTime"
      >
        <el-date-picker
          v-model="formStu.endTime"
          type="daterange"
          placeholder="学员课程结束时间"
          format="yyyy-MM-dd"
          placement="bottom-end"
          style="width: 250px; font-size: 10px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
export default {
  name: "queryStuBar",
  components: {},
  data() {
    return {
      formStu: {
        id: "",
        stuName: "",
        phone: "",
        signupDate: [],
        expireDate: [],
        status: "",
        endTime: [],
        weixinId: "",
        joinTime: "",
        groupName: "",
        teacherId: "",
      },
      queryData: [],
      statusList: [
        {
          value: 0,
          label: "注册",
        },
        {
          value: 1,
          label: "激活",
        },
        {
          value: 2,
          label: "活跃",
        },
        {
          value: 3,
          label: "到期",
        },
        {
          value: 4,
          label: "注销",
        },
      ],
      pickerOptions2: {
        shortcuts: [
          {
            text: "永久有效",
            onClick(picker) {
              picker.$emit("pick", ["2121-01-01", "2121-01-01"]);
            },
          },
        ],
      },
    };
  },
  props: {
    className: {
      type: Boolean,
      default: true,
    },
    signupDate: {
      type: Boolean,
      default: true,
    },
    endTime: {
      type: Boolean,
      default: false,
    },
    joinTime: {
      type: Boolean,
      default: false,
    },
    teacherId:{
      type: Boolean,
      default: false,
    },
     groupName:{
      type: Boolean,
      default: false,
    }
  },
  created() {
    this.fetchClassList();
  },
  mounted() {
    var _this = this;
    Bus.$on("stuListFilterByPhone", (e) => {
      let phone = e.phone;
      _this.formStu.phone = phone;
      _this.onQuery();
    });
  },
  watch: {},
  methods: {
    onQuery() {
      
      this.$emit("queryResult", this.formStu);
      
    },
    fetchClassList() {
      // this.loading = true;
      let params = {
        appId: this.$API.APPID,
        pageSize: 500,
        page: 1,
      };

      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/list", params).then(
        (res) => {
          if (res != null) {
            // debugger
            let m = JSON.parse(res).list;
            for (let i in m) {
              let temp = {
                label: m[i].name,
                value: `${m[i].id}`,
              };
              // debugger
              this.queryData.push(temp);
            }
            console.log(this.queryData);
          }
          this.loading = false;
        }
      );
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("stu_save") == -1 &&
                address.indexOf("stu_del") == -1 &&
                address.indexOf("stu_update") == -1
              ) {
                resolve(JSON.stringify(response.data.data));
              } else {
                resolve(JSON.stringify(response.data.msg));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";


</style>


// WEBPACK FOOTER //
// queryStuBar.vue?54061915